import React from 'react';
import classNames from 'classnames';

import { jobPostAppsUrl, jobPostAppUrl } from 'buyside/util/urlHelper';
import { useIsMobile } from 'buyside/util/hooks/useIsMobile';
import JobApplicationShowMutations, {
  JobApplication
} from 'buyside/components/container/JobApplicationShowPage/jobApplicationShowPageMutationsContainer';
import JobApplicationShowCard from 'buyside/components/presentation/JobApplicationShowPage/JobApplicationCard/JobApplicationShowCard';
import ApplicationOptions from 'buyside/components/presentation/JobApplicationShowPage/ApplicationOptions/ApplicationOptions';

import styles from './jobApplicationShowPageStyles.scss';

const JobApplicationShowPage: React.FC<{
  jobApplication: JobApplication;
}> = ({ jobApplication }) => {
  const {
    jobPosting,
    otherApplications,
    name,
    phone,
    email,
    coverNote,
    userId,
    status,
    resumeUrl,
    starred,
    jobPosting: { id: jobPostingId }
  } = jobApplication;

  const isMobile = useIsMobile();

  return (
    <>
      <h1 className={styles.title}>Applications for {jobPosting.title} Position</h1>
      <div className={classNames(styles.container, { [styles.responsiveContainer]: isMobile })}>
        <div className={styles.index}>
          <a className={styles.link} href={jobPostAppsUrl(jobPosting.id)}>
            {'<< Compare Candidates'}
          </a>

          <div className={styles.candidateListTitle}>Candidates</div>

          {otherApplications?.length ? (
            <div className={styles.candidateListContainer}>
              <ul className={styles.candidateList}>
                {otherApplications?.map(
                  ({ id, name }): React.ReactElement => (
                    <li key={`candidate-list-${id}`} className={styles.candidateListItem}>
                      <a className={styles.link} href={jobPostAppUrl(jobPosting.id, id)}>
                        {name}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>
          ) : (
            <div className={styles.noCandidateList}>No Other Candidates</div>
          )}
        </div>

        <div className={classNames(styles.show, { [styles.responsiveShow]: isMobile })}>
          <JobApplicationShowMutations jobApplication={jobApplication}>
            {({
              handleInterviewed,
              handleRejected,
              handleStarred,
              isFetching
            }): React.ReactElement => (
              <>
                <JobApplicationShowCard
                  handleInterviewed={handleInterviewed}
                  handleRejected={handleRejected}
                  handleStarred={handleStarred}
                  name={name}
                  phone={phone}
                  email={email}
                  coverNote={coverNote}
                  userId={userId}
                  status={status}
                  resumeUrl={resumeUrl}
                  starred={starred}
                />
                <ApplicationOptions
                  handleInterviewed={handleInterviewed}
                  handleRejected={handleRejected}
                  handleStarred={handleStarred}
                  isFetching={isFetching}
                  jobPostingId={jobPostingId}
                  status={status}
                  name={name}
                  starred={starred}
                  otherApplicationsCount={otherApplications?.length || 0}
                />
              </>
            )}
          </JobApplicationShowMutations>
        </div>
      </div>
    </>
  );
};

export default JobApplicationShowPage;
